import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AboutTheCourse from '../../../../components/jsx/learnings/courses/[id]/AboutTheCourse/AboutTheCourse';
import TOC from '../../../../components/jsx/learnings/courses/[id]/TableOfContents/TOC';
import InstructorCard from '../../../../components/jsx/learnings/courses/[id]/InstructorCard/InstructorCard';
import InfoCard from '../../../../components/jsx/learnings/courses/[id]/InfoCard/InfoCard';
import useCourseDetails from '../../../../hooks/useCourseDetails';

const CourseDetailPage = () => {
    // Get course and batch IDs from URL query parameters
    const [searchParams] = useSearchParams();
    const courseId = searchParams.get('courseId');
    const batchId = searchParams.get('batchId');
    
    // Fetch course details using the hook
    const { courseDetails, isLoading, error } = useCourseDetails(courseId, batchId);
    
    // Handle loading state - now handled by parent component
    if (isLoading) {
        return (
            <div className="w-full p-8 flex justify-center">
                <div className="animate-pulse text-lg">Loading course details...</div>
            </div>
        );
    }
    
    // Handle error state
    if (error) {
        return (
            <div className="w-full p-8">
                <div className="text-red-500 text-center">
                    <p className="text-lg">{error}</p>
                    <p className="mt-2">Please try again or contact support.</p>
                </div>
            </div>
        );
    }
    
    // Handle missing data
    if (!courseDetails) {
        return (
            <div className="w-full p-8">
                <div className="text-amber-600 text-center">
                    <p className="text-lg">Course not found</p>
                    <p className="mt-2">The course you're looking for doesn't exist or you don't have access.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-full w-full">
            {/* Large screens (md and above) - 2 column layout */}
            <div className="hidden md:grid md:grid-cols-12 md:gap-6">
                {/* Left column - spans 8 columns */}
                <div className="md:col-span-8 flex flex-col gap-6">
                    <AboutTheCourse courseData={courseDetails} />
                    <TOC curriculumData={courseDetails.curriculum} />
                </div>

                {/* Right column - spans 4 columns */}
                <div className="md:col-span-4 flex flex-col gap-6">
                    <InfoCard batchInfo={courseDetails.currentBatch} />
                    <InstructorCard instructorData={courseDetails.instructor} />
                </div>
            </div>

            {/* Small screens (below md) - 1 column layout with specific order */}
            <div className="flex flex-col gap-6 md:hidden">
                <AboutTheCourse courseData={courseDetails} />
                <InstructorCard instructorData={courseDetails.instructor} />
                <TOC curriculumData={courseDetails.curriculum} />
                <InfoCard batchInfo={courseDetails.currentBatch} />
            </div>
        </div>
    );
};

export default CourseDetailPage;